import { useEffect, useState } from "react";

/** Re-render periódico para que el cierre de loterías se actualice sin F5. */
export default function useNowTick(intervalMs = 15000) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return now;
}
